export default function(state=null,action){
  switch (action.type) {
    case "ORDER_DETAILS":
        return action.payload;
    default: return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducer/get_ship_order.js